export default "__VITE_ASSET__CuFS7EZF__"